//Lib
import { FieldType, ViewModelBase, ApiResult } from "@shoothill/core";
import { action, computed, observable, runInAction } from "mobx";

// App
import { AppUrls } from "AppUrls";
import { StoresInstance } from "Globals/Stores";
import { SaveStore } from "Globals/Stores/Domain";

// Models
import { AuditedAccountModel } from "Globals/Models/Domain/FormSections/EmploymentDetails/AuditedAccountModel";
import { AuditedAccountDTO } from "Globals/Models/DTO/AuditedAccountDTO";
import { UserFile } from "Globals/Models/UserFile";

// View models
import EmploymentDetailsViewModel from "./EmploymentDetailsViewModel";

export default class AuditedAccountViewModel extends ViewModelBase<AuditedAccountModel> {
    private saveStore: SaveStore = StoresInstance.Domain.SaveStore;

    constructor(auditedAccountModel?: AuditedAccountModel) {
        super(auditedAccountModel ? auditedAccountModel : new AuditedAccountModel());
        console.log(this.model.id);
    }

    @action
    public save = async (userFile: UserFile, employmentDetails: EmploymentDetailsViewModel, isDeleted: boolean = false): Promise<void> => {
        try {
            let valid = await this.isModelValid();
            if (isDeleted || valid) {
                this.setIsLoading(true);
                this.saveStore.setIsSaving(true);
                runInAction(() => {
                    this.model.employmentDetailId = employmentDetails.model.id ? employmentDetails.model.id : "";
                    this.model.fileName = userFile.fileName;
                    this.model.fileUrl = userFile.fileUrl;
                    this.model.isDeleted = isDeleted;
                });

                let upsertAuditedAccount: AuditedAccountDTO = this.model.toDto();
                const apiResult = await this.Post<AuditedAccountDTO>(AppUrls.Server.ApplicationForm.Upsert.AuditedAccount, upsertAuditedAccount);

                if (apiResult.wasSuccessful) {
                    this.model.fromDto(apiResult.payload);
                    console.info("AuditedAccount:Upsert-Successful");

                    let auditedAccountModel = new AuditedAccountModel();
                    auditedAccountModel.fromDto(apiResult.payload);
                    let auditedAccountViewModel = new AuditedAccountViewModel(auditedAccountModel);
                    runInAction(() => {
                        if (isDeleted) {
                            const index = employmentDetails.auditedAccountViewModels.indexOf(auditedAccountViewModel);
                            if (index > -1) {
                                employmentDetails.auditedAccountViewModels.splice(index, 1);
                            }
                        } else {
                            employmentDetails.auditedAccountViewModels.push(auditedAccountViewModel);
                        }
                    });

                    this.model.resetModel();
                    return Promise.resolve();
                } else {
                    console.error("AuditedAccount:Upsert-Error", apiResult.errors);
                    return Promise.reject(apiResult.errors);
                }
            }
        } catch (exception) {
            console.error(exception);
        } finally {
            this.saveStore.setIsSaving(false);
            this.setIsLoading(false);
        }
    };

    public async isFieldValid(fieldName: keyof FieldType<AuditedAccountModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);
        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
